import React, { createRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useTabs from '@bexs/dollar-hooks/useTabs';
import { updateFilter } from 'store/ducks/filter/actions';
import { ReportType } from 'store/ducks/statements/types';
import { useSelector } from 'store';
import filterDates from 'store/ducks/filter/filter-dates';
import { TabItem } from '@bexs/dollar';
import { TabListWrapper } from './styles';

const TabsBalance: React.FC = () => {
  const dispatch = useDispatch();

  const { indicatorConfig, updateTabIndicator } = useTabs();

  const selectedRef = createRef<HTMLLIElement>();

  const { reportType, periodStart, periodEnd, isFirstLoad } =
    useSelector().filter;

  useEffect(() => {
    return updateTabIndicator(selectedRef.current as HTMLLIElement);
  }, [reportType]);

  return (
    <div style={{ marginBottom: '16px' }}>
      <TabListWrapper
        data-testid="tab-list"
        indicatorWidth={indicatorConfig.width}
        indicatorPosition={indicatorConfig.left}
      >
        <TabItem
          data-testid="report-type-all"
          ref={reportType === ReportType.All ? selectedRef : null}
          isActive={reportType === ReportType.All}
          onClick={() => {
            if (reportType !== ReportType.All) {
              dispatch(
                updateFilter({
                  reportType: ReportType.All,
                })
              );
            }
          }}
        >
          All
        </TabItem>
        <TabItem
          data-testid="report-type-in"
          ref={reportType === ReportType.In ? selectedRef : null}
          isActive={reportType === ReportType.In}
          onClick={() => {
            dispatch(
              updateFilter({
                reportType: ReportType.In,
                periodStart: isFirstLoad ? filterDates.today.date : periodStart,
                periodEnd: isFirstLoad ? filterDates.today.date : periodEnd,
              })
            );
          }}
        >
          Income
        </TabItem>
        <TabItem
          data-testid="report-type-out"
          ref={reportType === ReportType.Out ? selectedRef : null}
          isActive={reportType === ReportType.Out}
          onClick={() => {
            dispatch(
              updateFilter({
                reportType: ReportType.Out,
              })
            );
          }}
        >
          Outcome
        </TabItem>
      </TabListWrapper>
    </div>
  );
};

export default TabsBalance;
